export default {
    type: 'dynamic-accordion',
    name: 'Dynamic Accordion',
    osOnly: true,
    components: {
        root: {
            name: 'ModuleDynamicAccordion',
            loader: () => import('./ModuleDynamicAccordion')
        }
    }
};
